import { Component } from '@theme/component';

class SizeQuickSelect extends Component {
  handleSizeClick = (event) => {
    const btn = event.target.closest('[data-variant-id]');
    if (!btn || btn.dataset.available === 'false') return;

    const variantInput = this.querySelector('input[ref="variantId"]');
    if (variantInput) variantInput.value = btn.dataset.variantId;

    const form = this.querySelector('form[data-type="add-to-cart-form"]');
    if (form) form.requestSubmit();
  };
}

if (!customElements.get('size-quick-select')) {
  customElements.define('size-quick-select', SizeQuickSelect);
}
